import React from 'react';

function winRateBadge(wr) {
    if (wr === null || wr === undefined) return <span className='text-muted'>—</span>;
    const cls = wr >= 55 ? 'bg-success' : wr >= 40 ? 'bg-warning text-dark' : 'bg-danger';
    return <span className={`badge py-1 ${cls}`}>{wr.toFixed(1)}%</span>;
}

function netBadge(net) {
    const cls = net > 0 ? 'text-success fw-bold' : net < 0 ? 'text-danger fw-bold' : 'text-muted';
    return <span className={cls}>{net > 0 ? '+' : ''}{net.toFixed(2)}</span>;
}

function returnBadge(pct) {
    if (pct === null || pct === undefined) return <span className='text-muted'>—</span>;
    const cls = pct > 0 ? 'text-success' : pct < 0 ? 'text-danger' : 'text-muted';
    return <span className={cls}>{pct > 0 ? '+' : ''}{pct.toFixed(2)}%</span>;
}

/**
 * props:
 * - data: [{ name, symbol, totalOrders, trades, winRate, net, returnPct }]
 */
function AutomationStats({ data }) {
    if (!data || !data.length) return null;

    return (
        <div className='card card-body border-0 shadow mb-4'>
            <h6 className='mb-3'>Performance por Automação</h6>
            <div className='table-responsive'>
                <table className='table table-hover table-sm mb-0'>
                    <thead>
                        <tr>
                            <th>Automação</th>
                            <th>Símbolo</th>
                            <th className='text-center'>Ordens</th>
                            <th className='text-center'>Trades</th>
                            <th className='text-center'>Win Rate</th>
                            <th className='text-end'>Retorno %</th>
                            <th className='text-end'>P&amp;L Líquido</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, i) => (
                            <tr key={i}>
                                <td><strong>{row.name}</strong></td>
                                <td>{row.symbol}</td>
                                <td className='text-center text-muted'>{row.totalOrders ?? '—'}</td>
                                <td className='text-center'>{row.trades || '—'}</td>
                                <td className='text-center'>{winRateBadge(row.winRate)}</td>
                                <td className='text-end'>{returnBadge(row.returnPct)}</td>
                                <td className='text-end'>{netBadge(row.net)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default AutomationStats;
